import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PRODUCT_VIEW_MODEL_CHANGE_EVENT_NAME } from '@df/catalog-ui/product/view/product-view.component.def';
import type { IProductDataV3 } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { NProductConfiguration } from '@df/module-product-configuration/df-module-product-configuration.interfaces';
import { ProductConfigurationConfigurable } from '@df/module-product-configuration/model/configurable/product-configuration-configurable';
import { ProductConfiguration } from '@df/module-product-configuration/model/product-configuration';
import { ProductDecorator } from '../../../catalog/model/product/product.decorator';

@Injectable()
export class ProductConfigurationPlugin implements NProductConfiguration.IPlugin {
    /**
     * Services
     */
    private productConfiguration!: ProductConfigurationConfigurable;
    private app = inject(App);
    private destroyRef = inject(DestroyRef);

    /**
     * Init
     */
    init(productConfiguration: ProductConfiguration) {
        this.productConfiguration = productConfiguration as ProductConfigurationConfigurable;

        this.productConfiguration.product$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.app.events.broadcast(PRODUCT_VIEW_MODEL_CHANGE_EVENT_NAME, this.productConfiguration.product$.value);
        });
    }

    getSelectionProduct(attributeCode: string): ProductDecorator<IProductDataV3> | undefined {
        const value = this.productConfiguration.selection$.value[attributeCode];
        const option = this.productConfiguration.options$.value
            ?.find(option => option.attribute.id === attributeCode)
            ?.values.find(option => option.value === value);

        if (option) {
            return option.product as ProductDecorator<IProductDataV3>;
        }

        return undefined;
    }

    needSelectAttribute(): string | undefined {
        const selection = this.productConfiguration.selection$?.value || {};
        const product = this.productConfiguration.product$?.value;

        if (Object.keys(selection).length) {
            return product.configurableAttributeCodes?.find(i => !selection[i]);
        }

        return undefined;
    }
}

ProductConfiguration.plugins.push(ProductConfigurationPlugin);
